define('views/parts/modal/zoom-meeting-created-modal',[
    'underscore',
    'mustache',
    'services/i18n',
    'services/user',
    'views/parts/modal/modal',
    'text!templates/parts/modal/zoom-meeting-created-modal.html',
], function(
    _, Mustache, i18n, User, VModal, TZoomMeetingCreatedModal
) {

    var VZoomMeetingCreatedModal = VModal.extend({
        template: TZoomMeetingCreatedModal,
        messageBody: "{{#t}}conversation:click-here-to-access-the-video-meeting{{/t}} <a href='{{join_url}}' target='_blank'>{{join_url}}</a>",

        modal: function() {
            return {
                title: i18n.t('conversation:your-meeting-is-ready'),
                size: 'medium'
            };
        },

        buttons: function() {
            return {
                confirm: {
                    label: i18n.t("Ok"),
                    callback: this.onConfirm,
                },
                post: {
                    label: i18n.t('conversation:send-via-message'),
                    callback: this.onPost
                }
            }
        },

        initialize: function(opt) {
            _.extend(this, opt);
        },

        render: function() {
            this.$el.empty().append(
                Mustache.render(this.template, Mustache.getContext({
                    start_url: User.zoomMeetingUrl()
                }))
            );

            this.renderModal();

            return this;
        },

        onPost: function() {
            this.chatbox.setValue(
                Mustache.render(this.messageBody, Mustache.getContext({
                    join_url: User.zoomMeetingUrl()
                }))
            );
        }
    });

    return VZoomMeetingCreatedModal;
});

